import {Text, TouchableOpacity, View} from 'react-native';
import OverlaySelect from '../../components/selectGrade';
import React from 'react';
import {createStyles} from '../../../../utils/createStyles';
interface BasicInfoProps {
  basicInfoName: string;
  userInfo: any;
  basicInfoObj: any;
  handleButtonPress: (title: string, basicInfo: any) => void;
  toggleOverlay: () => void;
  currentSubjectId: number;
  visible: boolean;
}
const BasicInfo: React.FC<BasicInfoProps> = ({
  basicInfoName,
  basicInfoObj,
  currentSubjectId,
  userInfo,
  visible,
  toggleOverlay,
  handleButtonPress,
}) => {
  return (
    <View style={styles.SynchroWorkbookBoxConRightTop}>
      <TouchableOpacity
        onPress={toggleOverlay}
        style={[styles.SynchroWorkbookBoxConRightTopBox]}>
        <Text style={styles.SynchroWorkbookBoxConRightTopBoxText}>
          {basicInfoName}
        </Text>
      </TouchableOpacity>
      <OverlaySelect
        isVisible={visible}
        subjectId={currentSubjectId}
        userInfo={userInfo}
        basicInfoObj={basicInfoObj}
        onBackdropPress={toggleOverlay}
        onButtonPress={(title, basicInfo) =>
          handleButtonPress(title, basicInfo)
        }
      />
    </View>
  );
};
const styles = createStyles({
  SynchroWorkbookBoxConRightTop: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: '.9rem',
  },
  SynchroWorkbookBoxConRightTopBox: {
    minWidth: '14.75rem',
    height: '3rem',
    backgroundColor: '#fff',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.75rem',
    paddingHorizontal: '1rem',
    zIndex: 999999,
  },
  SynchroWorkbookBoxConRightTopBoxText: {
    fontSize: '1.1rem',
    color: '#64617B',
  },
});
export default BasicInfo;
